import { render } from "./scroll-up-button.vue?vue&type=template&id=6f451be1"
import script from "./scroll-up-button.vue?vue&type=script&lang=js"
export * from "./scroll-up-button.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./scroll-up-button.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script